import React, { Fragment } from "react";
import InputAdornment from "@mui/material/InputAdornment";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import TextField from "@mui/material/TextField";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import InfoIcon from "@mui/icons-material/Info";
import ScheduleIcon from "@mui/icons-material/Schedule";
import RunningWithErrorsIcon from "@mui/icons-material/RunningWithErrors";

// "Acknowledge after N minutes back to normal": blank is off (null),
// otherwise a whole number from 1 to 10080 (7 days). Returns undefined when
// the entry is not valid, so the caller can refuse the save. Also reads the
// close wait ("after N minutes", blank = close at once).
export function parseAutoAckMinutes(value) {
  if (value === "" || value === null || value === undefined) return null;
  const minutes = Number(value);
  return Number.isInteger(minutes) && minutes >= 1 && minutes <= 10080
    ? minutes
    : undefined;
}

export default function Edit({
  form,
  payload,
  muteNotifications,
  open,
  setOpen,
}) {
  return (
    <Fragment>

    <div
      style={{
        height: "40vh",
        maxHeight: "380px",
        overflowY: "scroll",
      }}
    >
      <TextField
        disabled={true}
        id="number"
        variant="outlined"
        label="No sms Gateway integrated"
        fullWidth
        margin="dense"
        value={form.values.number}
        onChange={form.handleChange}
        helperText={"Hint: you can add multiple comma seperated numbers"}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <PhoneAndroidIcon
                style={{
                  color: "grey",
                }}
              />
            </InputAdornment>
          ),
        }}
      />
      <TextField
        id="email"
        label="Email"
        fullWidth
        margin="dense"
        value={form.values.email}
        onChange={form.handleChange}
        helperText={"Hint: you can add multiple comma seperated emails"}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <MailOutlineIcon
                style={{
                  color: "grey",
                }}
              />
            </InputAdornment>
          ),
        }}
      />
       <TextField
        id="measures"
        variant="outlined"
        label="Prescriptive Measures"
        fullWidth
        multiline
        margin="dense"
        value={form.values.measures}
        onChange={form.handleChange}
        inputProps={{
          style: {
            height: "90px",
          },
        }}
      />
     
    </div>
    <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={form.values.repeatNotification}
                onChange={(e) => {
                  form.setFieldValue("repeatNotification", e.target.checked);
                }}
              />
            }
            label="Notify on each violation"
          />
          <Tooltip
            title="Off: one e-mail per problem, sent when the problem starts. On: every matching reading is its own problem and sends its own e-mail."
            placement="top"
            arrow
            TransitionComponent={Zoom}
          >
            <InfoIcon style={{ color: "#9f9f9f" }} />
          </Tooltip>
        </span>
        <Tooltip
          title={
            "Manage quiet hours: e-mails in these hours are held and sent when they end"
          }
          placement="top"
          arrow
          TransitionComponent={Zoom}
        >
          <Button
            variant="outlined"
            startIcon={
              JSON.stringify(muteNotifications) == JSON.stringify(payload) ? (
                <ScheduleIcon color="secondary" fontSize="small" />
              ) : (
                <RunningWithErrorsIcon
                  sx={{ color: "#bf3535" }}
                  fontSize="small"
                />
              )
            }
            sx={{
              fontWeight:
                JSON.stringify(muteNotifications) == JSON.stringify(payload)
                  ? "normal"
                  : "bold",
              fontSize: 10,
              borderRadius: "6px !important",
              padding: "2px 10px !important",
              marginTop: "-5px",
            }}
            onClick={() => setOpen(!open)}
            color={
              JSON.stringify(muteNotifications) == JSON.stringify(payload)
                ? "secondary"
                : "error"
            }
          >
            Timetable
          </Button>
        </Tooltip>
      </div>
      {/* Only a lasting problem has a "back to normal": hidden for rules that
          notify on each violation and for zones that alarm both ways. */}
      {!(form.values.repeatNotification || form.values.alarmOn === "both") ? (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <FormControlLabel
            control={
              <Switch
                checked={form.values.allClearEmail}
                onChange={(e) => {
                  form.setFieldValue("allClearEmail", e.target.checked);
                }}
              />
            }
            label="E-mail when back to normal"
          />
          <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <FormControlLabel
              control={
                <Switch
                  checked={form.values.autoClose}
                  onChange={(e) => {
                    form.setFieldValue("autoClose", e.target.checked);
                  }}
                />
              }
              label="Close alarm when back to normal"
            />
            {form.values.autoClose ? (
              <TextField
                id="autoCloseMinutes"
                variant="outlined"
                type="number"
                size="small"
                label="after N minutes (blank = at once)"
                margin="dense"
                value={form.values.autoCloseMinutes}
                onChange={form.handleChange}
                sx={{ width: "250px" }}
              />
            ) : null}
          </span>
          <TextField
            id="autoAckMinutes"
            variant="outlined"
            type="number"
            label="Acknowledge after N minutes back to normal"
            margin="dense"
            value={form.values.autoAckMinutes}
            onChange={form.handleChange}
            helperText={"Leave blank to turn off"}
          />
        </div>
      ) : null}
    </Fragment>
  );
}
